export default __webpack_public_path__ + "static/media/KOD0032-min.44496a1c.webp";